const processInclude = require('./util');

$(document).ready(() => {
    processInclude(require('./flyer/flyer'));
});
